// Single source of truth for "which dashboard does this user belong to".
// Used by route guards and by legacy standalone routes that now redirect into
// a dashboard view so the page inherits that dashboard's navbar and shell.
export const getDashboardBase = () => {
    const role = localStorage.getItem('role');
    const isAdmin = localStorage.getItem('isAdmin') === 'true';

    if (role === 'student') return '/StudentDashboard';
    if (role === 'super_admin') return '/SuperAdminDashboard';
    if (role === 'admin') return '/StandaloneAdminDashboard';
    if (role === 'preceptor') return isAdmin ? '/AdminDashboard' : '/PreceptorDashboard';
    return null;
};

export const getDashboardViewPath = (view) => {
    const base = getDashboardBase();
    if (!base) return '/';
    return view && view !== 'dashboard' ? `${base}/${view}` : base;
};

// Admin-equivalent roles: they see the editable version of shared pages such as
// My Organization. Mirrors the backend `isAdmin` gate in routers/organization.py.
export const isAdminUser = () => {
    const role = localStorage.getItem('role');
    const isAdmin = localStorage.getItem('isAdmin') === 'true';
    return role === 'admin' || role === 'super_admin' || (role === 'preceptor' && isAdmin);
};
